import { EnvConfig } from '../config';

export const config: EnvConfig = {
  gtmId: 'GTM-N53DH7Z',
  gtmAuth: 'S83AeSq-waYw0JdXvfxZ7g',
  gtmPreview: 'env-8',
  splitIoAuthKey: 'djvj9shq0j30h1d6puedd61k41jlfsh9nevq',
};
